import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const LeftPanelCloseSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default LeftPanelCloseSVG;
